import { IReducerState } from 'store/main-reducer';

export const getIsLoading = (state: IReducerState) => state.callbackRequestReducer.isLoading;
export const getIsSubmitted = (state: IReducerState) => state.callbackRequestReducer.isSubmitted;
export const getError = (state: IReducerState) => state.callbackRequestReducer.error;
export const getHasSubmittedSilent = (state: IReducerState) => state.callbackRequestReducer.hasSubmittedSilent;
